<template>
  <div class="app">
    <el-container>
      <el-aside style="min-height: 800px;" class="app-side app-side-left"
                :class="isCollapse ? 'app-side-collapsed' : 'app-side-expanded'">
        <div class="app-side-logo" style="line-height: 60px; font-size: 24px;">
          <i class="el-icon-setting"></i><span v-if="!isCollapse">后台管理</span>
        </div>
        <div>
          <!-- 我是样例菜单 -->
          <el-menu :default-active="defAction"
                   class="el-menu-vertical-demo"
                   @open="handleOpen"
                   router
                   :default-openeds="opends"
                   :collapse="isCollapse">
            <el-submenu index="1"
                        v-if="!user.power
                        || user.power.indexOf('/company')!=-1
                        || user.power.indexOf('/user')!=-1
                        || user.power.indexOf('/logs')!=-1
                        || user.power.indexOf('/qutype')!=-1
                        "
                        :show-timeout="0" :hide-timeout="0">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">基础数据</span>
              </template>
              <el-menu-item @click="ue_menuClick" v-if="(!user.power || user.power.indexOf('/company')!=-1)" route="/company" index="1-1">公司信息</el-menu-item>
              <el-menu-item @click="ue_menuClick" v-if="(!user.power || user.power.indexOf('/user')!=-1)" route="/user" index="1-2">操作人员</el-menu-item>
              <el-menu-item @click="ue_menuClick" v-if="(!user.power || user.power.indexOf('/logs')!=-1)" route="/logs" index="1-3">登录日志</el-menu-item>
              <el-menu-item @click="ue_menuClick" v-if="(!user.power || user.power.indexOf('/qutype')!=-1)" route="/qutype" index="1-4">资质类型</el-menu-item>
            </el-submenu>
            <el-submenu index="2" :show-timeout="0"
                        v-if="!user.power || user.power.indexOf('/agents')!=-1 || user.power.indexOf('/sign')!=-1"
                        :hide-timeout="0">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span slot="title">签约管理</span>
              </template>
              <el-menu-item @click="ue_menuClick" route="/agents" v-if="(!user.power || user.power.indexOf('/agents')!=-1)" index="2-1">客户档案</el-menu-item>
              <el-menu-item @click="ue_menuClick" route="/sign" v-if="(!user.power || user.power.indexOf('/sign')!=-1)" index="2-2">签约登记</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>

      <el-container class="df">
        <el-header class="app-header">
          <div style="width: 30px; cursor: pointer;"
               @click.prevent="toggleSideBar">
            <i v-show="!isCollapse" class="el-icon-d-arrow-left"></i>
            <i v-show="isCollapse" class="el-icon-d-arrow-right"></i>
          </div>
          <!-- 我是样例菜单 -->
          {{defrute}}
          <div class="app-header-userinfo">
            <el-dropdown trigger="hover"
                         :hide-on-click="false">
              <span class="el-dropdown-link">
                {{ user.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="ue_updateSys">升级系统</el-dropdown-item>
                <el-dropdown-item @click.native="ue_gotoChangePwd">密码修改</el-dropdown-item>
                <el-dropdown-item divided
                                  @click.native="logout">退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main class="app-body">
          <template>
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </template>
          <icp-footer></icp-footer>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import * as Api from '../api/api'
  import IcpFooter from "./footer.vue";

  export default {
    components: {IcpFooter},
    data() {
      return {
        defAction: "",
        defrute: "首页",
        opends: ["1", "2"],
        isCollapse: false,
        user: JSON.parse(sessionStorage.getItem("user"))
      }
    },
    mounted() {
      this.defAction = this.$route.meta.index;
      this.defrute = this.$route.meta.label;
    },
    methods: {
      ue_menuClick() {
        this.defAction = this.$route.meta.index;
        this.defrute = this.$route.meta.label;
        return true;
      },
      toggleSideBar() {
        this.isCollapse = !this.isCollapse;
        if (!this.isCollapse) {
          this.opends = ["1", "2"];
        }
      },
      logout: function () {
        this.$confirm('确认退出?', '提示', {})
          .then(() => {
            sessionStorage.removeItem('user');
            this.$router.push('/login');
          })
          .catch(() => {
          });
      },
      ue_gotoChangePwd() {
        this.$router.push("/cpwd");
        this.defAction = this.$route.meta.index;
        this.defrute = this.$route.meta.label;
      },
      ue_updateSys() {
        Api.UpdateSys().then(res => {
          this.$alert(res);
        });
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue